module.exports = __webpack_public_path__ + "img/IMG_1962_P_FoamcoreMatted_MockedUp.d90b00a2.jpg";